import CurrencyCell from 'components/CustomGridCell/CurrencyCell';
import { AdjustmentType } from 'enums';
import { AdjustmentCategoryGridProps } from 'types';

const props: AdjustmentCategoryGridProps = {
    category: AdjustmentType.Pricing,
    adjustmentTypes: [AdjustmentType.Pricing, AdjustmentType.SpecialPricing],
    title: 'Pricing Adjustment',
    dataItemKey: 'rowNumber',
    selectMode: 'multiple',
    gridColumns: [
        {
            field: 'manufacturerItemNumber',
            title: 'Manufacturer Item ID',
            filterTitle: 'text'
        },
        {
            field: 'inventoryItemId',
            title: 'Dot Item Number',
            filterTitle: 'text'
        },
        {
            field: 'voucherQuantity',
            title: 'Quantity',
            filterTitle: 'numeric'
        },
        {
            field: 'originalLineAmount',
            title: 'Original Amount',
            cell: CurrencyCell,
            filterTitle: 'numeric'
        },
        {
            field: 'voucherLineAmount',
            title: 'Amount',
            cell: CurrencyCell,
            filterTitle: 'numeric'
        },
        {
            field: 'adjustmentAmount',
            title: 'Difference',
            cell: CurrencyCell,
            filterTitle: 'numeric'
        }
    ]
}
export default props;